module.exports = __webpack_public_path__ + "img/settings.7d723bd2.svg";